import { supabase } from '@/integrations/supabase/client';

export const uploadQualificationDocument = async (
  file: File,
  userId: string
): Promise<{ success: boolean; url?: string; error?: any }> => {
  try {
    // Validate file size (10MB limit)
    if (file.size > 10 * 1024 * 1024) {
      return { success: false, error: "File too large. Maximum size is 10MB" };
    }

    // Validate file type
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      return { success: false, error: "Invalid file type. Only PDF, JPG, JPEG, and PNG files are allowed" };
    }

    // Create unique filename
    const fileExt = file.name.split('.').pop() || 'bin';
    const fileName = `${userId}/${Date.now()}-qualification.${fileExt}`;
    
    // Upload to storage
    const { data, error: uploadError } = await supabase.storage
      .from('qualification-documents')
      .upload(fileName, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) {
      console.error("Upload failed:", uploadError);
      return { success: false, error: uploadError };
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('qualification-documents')
      .getPublicUrl(fileName);

    return { success: true, url: publicUrl };
  } catch (error) {
    console.error('Exception during file upload:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Upload failed' 
    };
  }
};

export const validateQualificationFile = (file: File): { valid: boolean; error?: string } => {
  // Check file size
  if (file.size > 10 * 1024 * 1024) {
    return { valid: false, error: "File too large. Maximum size is 10MB" };
  }
  
  // Check file type
  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
  if (!allowedTypes.includes(file.type)) {
    return { valid: false, error: "Invalid file type. Only PDF, JPG, JPEG, and PNG files are allowed" };
  }
  
  return { valid: true };
};